import Vue from 'vue';
import Vuex from 'vuex';
// import panel from "@/store/panel";
// import command from "@/store/command";
import * as Longan from 'gs-longan';

Vue.use(Vuex);

let viewer: Longan.Viewer = null
let viewerList: Longan.Viewer[] = []
let viewer2d: Longan.Viewer = null
let viewModel: Longan.ViewModel = null

const store = new Vuex.Store({
    modules: {
        // panel,
        // command,
    },

    state: {
        viewer,
        viewerList,
        viewer2d,
        viewModel,
        treeData: [],
        viewerLoading: false,
        activeNumScreen: "1",
        viewerVisible: false,
        modelName: "",
        modelProgress: 0,
        showTableData: false,
        componentSelectorId: "",
        isLonganLoaded: false,
        properties: [],
        // topZIndex: 1000,
        componentZIndex: {}

    },
    getters: {
        viewer: (state) => (viewerId) => {
            console.log(viewerId,)
            for (let i = 0; i < state.viewerList.length; i++) {
                if (state.viewerList[i].container.id === viewerId) {
                    return state.viewerList[i];
                }
            }
        },
    },

    mutations: {
        viewerInstance(state, viewer) {
            // state.viewer = viewer;
            // console.log(viewer)
            state.viewerList.push(viewer);
            state.viewer = viewer
        },
        viewerSwitch(state, viewerId) {
            for (let i = 0; i < state.viewerList.length; i++) {
                if (state.viewerList[i].container.id === viewerId) {
                    state.viewer = state.viewerList[i]
                    break
                }
            }
        },
        viewer2dInstance(state, viewer) {
            state.viewer2d = viewer;
        },
        viewModelInstance(state, viewModel) {
            state.viewModel = viewModel;
            console.log(viewModel)
        },
        treeDataInstance(state, treeData) {
            state.treeData = treeData;
        },
        viewerShow(state, viewerVisible: boolean) {
            state.viewerVisible = viewerVisible
        },
        activeNumScreenCommit(state, activeNumScreen) {
            state.activeNumScreen = activeNumScreen;

        },
        setModelName(state, modelName) {
            state.modelName = modelName
        },
        modelProgress(state, progress) {
            state.modelProgress = progress
        },
        showTableData(state, visible) {
            state.showTableData = visible
        },
        setComponentSelectorId(state, id) {
            state.componentSelectorId = id
        },
        propertiesChange(state, properties) {
            state.properties = properties
        },
        // updateTopZIndex(state) {
        //     state.topZIndex = state.topZIndex + 1
        // },
        setComponentZIndex(state, componentName) {
            let arr = Object.keys(state.componentZIndex)
            // console.log(state.componentZIndex)
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === componentName) {
                    continue
                }
                // state.componentZIndex[arr[i]] = state.componentZIndex[arr[i]] - 1
                Vue.set(state.componentZIndex, arr[i], state.componentZIndex[arr[i]] - 1);
            }
            Vue.set(state.componentZIndex, componentName, 1001);
        },

    },
    actions: {},
});

export default store;
